
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
    namespaced: true,
    state: {
        endpoint: "clubs",
        object: "club",
        header: [
            { text: "Activity", value: "id" },
            { text: "Name", value: "name" },
            { text: "Location", value: "location" },
            { text: "Price", value: "price" },
            { text: "Actions", value: "actions", sortable: false },
        ],
        list: [],
        page: 1,
        total: 0,
        options: {
            itemsPerPage: 10,
            search: ""
        },
    },
    mutations: {
        request(state) {
            state.status = "loading";
        },
        success(state, data) {
            state.status = "success";
            if (data && data["list"]) {
                state.list = data["list"];
            }
            if (data && data["total"]) {
                state.total = data["total"];
            }
        },
        error(state) {
            state.status = "error";
        },
        options(state, data) {
            state.options = data;
        }
    },
    actions: {
        getWatchedVideos({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                };
                axios
                    .get(config.api_url + "list_watched_videos", {
                        params: filter
                    })
                    .then(response => {
                        commit("success", {
                            list: response.data,
                            total: parseInt(
                                response.headers["pagination-count"]
                            )
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },

    },
    getters: {
        status(state) {
            return state.status;
        }
    },
};
